module.exports = __webpack_public_path__ + "static/target-fff872f0335aa9f8c9b488675d9a6e49.png";